import { ActionCreator } from "../types/store-types";
import {
    AuthActionTypes,
    InitUserRequestActionType,
    InitUserSuccessActionType,
    InitUserFailureActionType,
    SignInRequestActionType,
    SignInSuccessActionType,
    SignInFailureActionType,
    SignUpRequestActionType,
    SignUpSuccessActionType,
    SignUpFailureActionType,
    SetUserTokenActionType,
    SetLoadingActionType,
    ClearErrorsActionType,
    ConfirmUserRequestActionType,
    ConfirmUserSuccessActionType,
    ConfirmUserFailureActionType,
    ForgotPasswordRequestActionType,
    ForgotPasswordSuccessActionType,
    ForgotPasswordFailureActionType,
    GoogleLoginRequestActionType,
    GoogleLoginFailureActionType,
    SetRedirectUrlActionType,
    GoogleLoginSuccessActionType,
    OAuthFlowRequestActionType,
    OAuthFlowSuccessActionType,
    OAuthFlowFailureActionType,
} from "./types";

/* -- Init User Request Action -- */

export const initUserRequest: ActionCreator<InitUserRequestActionType> = payload => ({
    type: AuthActionTypes.INIT_USER_REQUEST,
    payload,
});

export const initUserSuccess: ActionCreator<InitUserSuccessActionType> = payload => ({
    type: AuthActionTypes.INIT_USER_SUCCESS,
    payload,
});

export const initUserFailure: ActionCreator<InitUserFailureActionType> = payload => ({
    type: AuthActionTypes.INIT_USER_FAILURE,
    payload,
});

/* -- Sign In Request Action -- */

export const signInRequest: ActionCreator<SignInRequestActionType> = payload => ({
    type: AuthActionTypes.SIGN_IN_REQUEST,
    payload,
});

export const signInSuccess: ActionCreator<SignInSuccessActionType> = payload => ({
    type: AuthActionTypes.SIGN_IN_SUCCESS,
    payload,
});

export const signInFailure: ActionCreator<SignInFailureActionType> = payload => ({
    type: AuthActionTypes.SIGN_IN_FAILURE,
    payload,
});

/* -- Sign Up Request Action -- */

export const signUpRequest: ActionCreator<SignUpRequestActionType> = payload => ({
    type: AuthActionTypes.SIGN_UP_REQUEST,
    payload,
});

export const signUpSuccess: ActionCreator<SignUpSuccessActionType> = payload => ({
    type: AuthActionTypes.SIGN_UP_SUCCESS,
    payload,
});

export const signUpFailure: ActionCreator<SignUpFailureActionType> = payload => ({
    type: AuthActionTypes.SIGN_UP_FAILURE,
    payload,
});

/* -- Confirm User Request Action -- */

export const confirmUserRequest: ActionCreator<ConfirmUserRequestActionType> = payload => ({
    type: AuthActionTypes.CONFIRM_USER_REQUEST,
    payload,
});

export const confirmUserSuccess: ActionCreator<ConfirmUserSuccessActionType> = payload => ({
    type: AuthActionTypes.CONFIRM_USER_SUCCESS,
    payload,
});

export const confirmUserFailure: ActionCreator<ConfirmUserFailureActionType> = payload => ({
    type: AuthActionTypes.CONFIRM_USER_FAILURE,
    payload,
});

export const setUserToken: ActionCreator<SetUserTokenActionType> = payload => ({
    type: AuthActionTypes.SET_USER_TOKEN,
    payload,
});

export const setAuthLoading: ActionCreator<SetLoadingActionType> = payload => ({
    type: AuthActionTypes.SET_LOADING,
    payload,
});

export const clearAuthErrors: ActionCreator<ClearErrorsActionType> = payload => ({
    type: AuthActionTypes.CLEAR_ERRORS,
    payload,
});

export const setRedirectUrl: ActionCreator<SetRedirectUrlActionType> = payload => ({
    type: AuthActionTypes.SET_REDIRECT_URL,
    payload,
});

/* OAuth */
export const oauthFlowRequest: ActionCreator<OAuthFlowRequestActionType> = payload => ({
    type: AuthActionTypes.OATUH_FLOW_REQUEST,
    payload,
});

export const oauthFlowSuccess: ActionCreator<OAuthFlowSuccessActionType> = payload => ({
    type: AuthActionTypes.OATUH_FLOW_SUCCESS,
    payload,
});

export const oauthFlowFailure: ActionCreator<OAuthFlowFailureActionType> = payload => ({
    type: AuthActionTypes.OATUH_FLOW_FAILURE,
    payload,
});

/* -- Forgot Password Request Action -- */

export const forgotPasswordRequest: ActionCreator<ForgotPasswordRequestActionType> = payload => ({
    type: AuthActionTypes.FORGOT_PASSWORD_REQUEST,
    payload,
});

export const forgotPasswordSuccess: ActionCreator<ForgotPasswordSuccessActionType> = payload => ({
    type: AuthActionTypes.FORGOT_PASSWORD_SUCCESS,
    payload,
});

export const forgotPasswordFailure: ActionCreator<ForgotPasswordFailureActionType> = payload => ({
    type: AuthActionTypes.FORGOT_PASSWORD_FAILURE,
    payload,
});

/* Google */
export const googleLoginRequest: ActionCreator<GoogleLoginRequestActionType> = payload => ({
    payload,
    type: AuthActionTypes.GOOGLE_LOGIN_REQUEST,
});
export const googleLoginSuccess: ActionCreator<GoogleLoginSuccessActionType> = payload => ({
    payload,
    type: AuthActionTypes.GOOGLE_LOGIN_SUCCESS,
});
export const googleLoginFailure: ActionCreator<GoogleLoginFailureActionType> = payload => ({
    payload,
    type: AuthActionTypes.GOOGLE_LOGIN_FAILURE,
});
